import _default from './Input';
export { _default as default };


//////////////////
// WEBPACK FOOTER
// ./node_modules/semantic-ui-react/dist/es/elements/Input/index.js
// module id = 160
// module chunks = 0